module.exports = "https://cdn.realtymogul.com/static/media/RP_Trinityplace.e8736453.jpg";